import {
  FundingRequestProvider,
  FundingRequestType,
  IAccInvoiceFundingRequest,
  IPatient,
  IPractice,
} from '@principle-theorem/principle-core/interfaces';
import {
  AtLeast,
  Firestore,
  IReffable,
  WithRef,
  multiUndeleted,
  where,
} from '@principle-theorem/shared';
import { Observable } from 'rxjs';
import { Practice } from '../../practice/practice';
import { FundingRequest } from '../funding-request';

export class AccInvoiceFundingRequest {
  static init(
    overrides: AtLeast<IAccInvoiceFundingRequest, 'data' | 'patient'>
  ): IAccInvoiceFundingRequest {
    return FundingRequest.init({
      type: FundingRequestType.Claim,
      fundingProvider: FundingRequestProvider.ACC,
      ...overrides,
    });
  }

  static all$(
    practice: WithRef<IPractice>
  ): Observable<WithRef<IAccInvoiceFundingRequest>[]> {
    return Firestore.query$(
      Practice.fundingRequestCol<IAccInvoiceFundingRequest>(practice),
      where('fundingProvider', '==', FundingRequestProvider.ACC),
      where('type', '==', FundingRequestType.Claim)
    ).pipe(multiUndeleted());
  }

  static byPatient$(
    practice: IReffable<IPractice>,
    patient: IReffable<IPatient>
  ): Observable<WithRef<IAccInvoiceFundingRequest>[]> {
    return Firestore.query$(
      Practice.fundingRequestCol<IAccInvoiceFundingRequest>(practice),
      where('fundingProvider', '==', FundingRequestProvider.ACC),
      where('type', '==', FundingRequestType.Claim),
      where('patient.ref', '==', patient.ref)
    ).pipe(multiUndeleted());
  }
}
